
import PricingAPIService from '@/modules/pricing/services/apiService'

export default class PricingModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.pricingService = new PricingAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/pricing/requests',
        name: 'PriceRequestList',
        component: () => import('@/modules/pricing/views/priceRequestList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Price Update List',
          menuLink: '/pricing/requests',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Pricing', link: ''}
          ],
        }
      },
      {
        path: '/pricing/requests/:id(\\d+)',
        name: 'PriceRequest',
        component: () => import('@/modules/pricing/views/priceRequest.vue'),
        meta: {
          requiresAuth: true,
          title: 'Price Update Request',
          menuLink: '/pricing/requests',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Pricing', link: ''},
            { title: 'Price Update List', link: '/pricing/requests'}
          ],
        }
      },
      {
        path: '/pricing/customer/:customerId/pricelist/:id(\\d+)',
        name: 'CustomerPriceList',
        component: () => import('@/modules/pricing/views/customerPriceList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Customer Price List',
          menuLink: '/contacts',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Pricing', link: '/pricing'},
          ],
        }
      },
      {
        path: '/pricing/customer/:customerId/pricelist/new',
        name: 'CustomerPriceListNew',
        component: () => import('@/modules/pricing/views/customerPriceList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Customer Price List',
          menuLink: '/contacts',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Pricing', link: '/pricing'},
          ],
        }
      },
      {
        path: '/pricing/customer/:customerId/pricelistconfig',
        name: 'CustomerPriceListConfig',
        component: () => import('@/modules/pricing/views/customerPriceListConfig.vue'),
        meta: {
          requiresAuth: true,
          title: 'Customer Price List Configuration',
          menuLink: '/contacts',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Contacts', link: '/contacts'},
          ],
        }
      },
      {
        path: '/pricing/requests/priceupdate',
        name: 'PriceUpdateTool',
        component: () => import('@/modules/pricing/views/priceUpdateTool.vue'),
        meta: {
          requiresAuth: true,
          title: 'Price Update Tool',
          menuLink: '/pricing/requests',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Pricing', link: ''}
          ],
        }
      },
      {
        path: '/pricing/requests/:id(\\d+)/priceupdate',
        name: 'PriceUpdateToolEdit',
        component: () => import('@/modules/pricing/views/priceUpdateTool.vue'),
        meta: {
          requiresAuth: true,
          title: 'Price Update Tool',
          menuLink: '/pricing/requests',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Pricing', link: ''}
          ],
        }
      },
      {
        path: '/pricing/configuration',
        name: 'PricingConfiguration',
        component: () => import('@/modules/pricing/views/pricingConfiguration.vue'),
        meta: {
          requiresAuth: true,
          title: 'Pricing Configuration',
          menuLink: '/pricing/configuration',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Pricing', link: ''}
          ],
        }
      },
      {
        path: '/pricing/pricelisttemplates',
        name: 'PriceListTemplate',
        component: () => import('@/modules/pricing/views/priceListTemplateList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Price List Templates',
          menuLink: '/pricing/pricelisttemplates',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Pricing', link: ''},
          ],
        }
      },
      {
        path: '/pricing/pricelisttemplates/:id(\\d+)',
        name: 'PriceListTemplate',
        component: () => import('@/modules/pricing/views/priceListTemplate.vue'),
        meta: {
          requiresAuth: true,
          title: 'Price List Template',
          menuLink: '/pricing/pricelisttemplates',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Pricing', link: ''},
          ],
        }
      },
      {
        path: '/pricing/pricelisttemplates/new',
        name: 'PriceListTemplateNew',
        component: () => import('@/modules/pricing/views/priceListTemplateNew.vue'),
        meta: {
          requiresAuth: true,
          title: 'New Price List Template',
          menuLink: '/pricing/pricelisttemplates',
          breadcrumbs: [
            { title: 'Home', link: '/'},
            { title: 'Pricing', link: ''},
          ],
        }
      },
    ]
  }
}